const axios = require('axios');

const BACK_API_URL = '/coreService';

export const getPublicDevis = async (id, token) => {
	try {
		const url = `${BACK_API_URL}/signature-devis/${id}/${token}`;

		const response = await axios.get(url);

		return response.data;
	} catch (error) {
		console.error('Error fetching public devis:', error);

		// Re-throw a cleaner error to handle in the UI
		throw error.response?.data?.message || 'Impossible de récupérer le devis public.';
	}
};

export const acceptPublicDevis = async (id, token, data) => {
	try {
		const url = `${BACK_API_URL}/signature-devis/accept/${id}/${token}`;

		const response = await axios.put(url, data);

		return response.data;
	} catch (error) {
		console.error('Error fetching public devis:', error);

		// Re-throw a cleaner error to handle in the UI
		throw error.response?.data?.message || 'Impossible de récupérer le devis public.';
	}
};

export const refusPublicDevis = async (id, token, data) => {
	try {
		const url = `${BACK_API_URL}/signature-devis/refuser/${id}/${token}`;

		const response = await axios.put(url, data);

		return response.data;
	} catch (error) {
		console.error('Error fetching public devis:', error);

		// Re-throw a cleaner error to handle in the UI
		throw error.response?.data?.message || 'Impossible de récupérer le devis public.';
	}
};

export const getPaymentLink = async (data) => {
	try {
		const url = `${BACK_API_URL}/email/dmk/public`;

		const response = await axios.post(url, data);

		return response.data;
	} catch (error) {
		console.error('Error fetching public devis:', error);

		// Re-throw a cleaner error to handle in the UI
		throw error.response?.data?.message || 'Impossible de récupérer le devis public.';
	}
};